/** Multi-series palette — 10 muted hues mapped to --chart-* in index.css. */
export const CHART_SERIES_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
  "var(--chart-6)",
  "var(--chart-7)",
  "var(--chart-8)",
  "var(--chart-9)",
  "var(--chart-10)",
] as const;

export type ChartSeriesColor = (typeof CHART_SERIES_COLORS)[number];

export const getChartSeriesColor = (index: number): ChartSeriesColor =>
  CHART_SERIES_COLORS[index % CHART_SERIES_COLORS.length];
